"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImpersonationToken = exports.getCustomerSearch = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCustomerSearch = function getCustomerSearch(url, apiPath, query) {
  return (0, _axios.default)({
    url: "".concat(url).concat(apiPath),
    method: 'GET',
    params: {
      filter: query
    },
    paramsSerializer: function paramsSerializer(params) {
      return "filter=".concat(encodeURIComponent(query));
    }
  }).then(function (res) {
    return res.data;
  }).catch(function (error) {
    throw error.response;
  });
};

exports.getCustomerSearch = getCustomerSearch;

var getImpersonationToken = function getImpersonationToken(url, customer) {
  return _axios.default.get("".concat(url)).then(function (res) {
    return res.data;
  }).catch(function (error) {
    throw error;
  });
};

exports.getImpersonationToken = getImpersonationToken;